import { render, staticRenderFns } from "./RptOrdenesRemitos.vue?vue&type=template&id=118d801c&"
import script from "./RptOrdenesRemitos.vue?vue&type=script&lang=js&"
export * from "./RptOrdenesRemitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports